module.exports = __webpack_public_path__ + "static/media/Right 5-1.fe89fe63.svg";